<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <div class="flex flex-nowrap gap-2 items-center justify-center">
    <div class="text-big text-gray-800">
      {{ t('Dont_have_account_Q') }}
    </div>
    <ButtonLevel
      type="4"
      :title="t('Sign_up')"
      @click="navigateTo('/sign-up')"
    />
  </div>
</template>

<style scoped>

</style>
